import axios from '../../config/axios';
import getEnv from '../getEnv';

const context = getEnv('usuario');

export default {
  getReCaptchaKey: async () => {
    let data;
    try {
      const response = await axios.get(`${context}/recaptcha/chave`);

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
};
